// frontend/src/assets/icons/nav/index.ts
// Maps a stable key to the bundled icon URL. Webpack handles the asset import.

import documentProcessing from './Document Processing.svg';
import tamperingDetection from './Tampering Detection.svg';
import emailProcessor from './Email Processor.svg';
import tariffClassifier from './Tarifff Classifier.svg';
import exportControl from './Export Control.svg';
import documentSets from './Document Sets.svg';
import aiLearningModule from './AI Learning Module.svg';
import businessIntelligence from './Business Intelligence.svg';
import customsAudit from './Customs Audit.svg';
import documentClassifier from './Document Classifier.svg';
import pdfSecurityScanner from './PDF Security Scanner.svg';
import nlpRulesEngine from './NLP_Rules_Engine.svg';
import complianceEngine from './Compliance_Engine.svg';
import supplierDeclarations from './Supplier_Declarations.svg';
import transactionHistory from './Transaction History.svg';
import myFiles from './My Files.svg';
import settings from './Settings.svg';
import profile from './Profile.svg';

import headerInformation from './Header Information.svg';
import exporter from './Exporter (Your Company).svg';
import recipient from './Recipient (Buyer).svg';
import declarant from './Declarant (Anmelder).svg';
import lineItems from './Line Items.svg';
import allErrors from './All Errors.svg';

import uploadDocument from './Upload document.svg';
import analyse from './Analyse.svg';
import review from './Review.svg';
import dragDrop from './Drag & drop.svg';
import uploadExclamation from './Upload exclamation.svg';

import applyAllPredictions from './Apply All Predictions.svg';
import loadFromHistory from './Load from History.svg';
import reset from './Reset.svg';
import teachAi from './Teach AI.svg';
import auditDeclaration from './Audit Declaration.svg';
import validate from './Validate.svg';

import atlas from './Atlas.svg';
import ausfuhr from './Ausfuhr.svg';
import einfuhr from './Einfuhr.svg';
import eas from './EAS.svg';
import praferenzKalkulation from './Praferenz Kalkulation.svg';
import sanktionsList from './Sanktions List Enorufung.svg';
import exportKontrolle from './Export Kontrolle.svg';
import fredi from './FREDi.svg';

import menuIcon from './Menu.svg';
import pinIcon from './Pin.svg';
import plusIcon from './Plus.svg';
import crossIcon from './Cross.svg';
import dotIcon from './Dot.svg';
import dotIcon1 from './Dot(1).svg';

import sidebarCollapse from './sidebar-collapse.png';
import sidebarExpand from './sidebar-expand.png';

export const navIcons = {
  documentProcessing,
  tamperingDetection,
  emailProcessor,
  tariffClassifier,
  exportControl,
  documentSets,
  aiLearningModule,
  businessIntelligence,
  customsAudit,
  documentClassifier,
  pdfSecurityScanner,
  nlpRulesEngine,
  complianceEngine,
  supplierDeclarations,
  transactionHistory,
  myFiles,
  settings,
  profile,
};

export const formIcons = {
  headerInformation,
  exporter,
  recipient,
  declarant,
  lineItems,
  allErrors,
};

export const stepperIcons = {
  uploadDocument,
  analyse,
  review,
  dragDrop,
  uploadExclamation,
};

export const actionIcons = {
  applyAllPredictions,
  loadFromHistory,
  reset,
  teachAi,
  auditDeclaration,
  validate,
};

export const moduleIcons = {
  atlas,
  ausfuhr,
  einfuhr,
  eas,
  praferenzKalkulation,
  sanktionsList,
  exportKontrolle,
  fredi,
};

export const uiIcons = {
  menu: menuIcon,
  pin: pinIcon,
  plus: plusIcon,
  cross: crossIcon,
  dot: dotIcon,
  dotFilled: dotIcon1,
  sidebarCollapse,
  sidebarExpand,
};
